export type TWasmTextureNames = "always-on-map" | "big-active" | "big-inactive" | "big-universal-active" | "big-universal-inactive" | "geo-location" | "height-profile" | "little-active"
	| "little-inactive" | "measure-points-active" | "measure-points-inactive" | "measure-start-active" | "measure-start-inactive" | "mhd-boat" | "mhd-bus"
	| "mhd-cable" | "mhd-map-boat" | "mhd-map-bus" | "mhd-map-cable" | "mhd-map-metro-a" | "mhd-map-metro-b" | "mhd-map-metro-c" | "mhd-map-metro-d"
	| "mhd-map-metro" | "mhd-map-train" | "mhd-map-tram" | "mhd-map-trolley" | "mhd-metro-a" | "mhd-metro-b" | "mhd-metro-c" | "mhd-metro-d" | "mhd-metro"
	| "mhd-standing" | "mhd-train" | "mhd-tram" | "mhd-trolley" | "mhd-walk" | "pano" | "photo-active" | "photo-inactive" | "position-share-device-active"
	| "position-share-device-inactive" | "position-share-image-active" | "position-share-image-arrow" | "position-share-image-inactive" | "small-active"
	| "small-gray" | "small-inactive" | "small-universal-active" | "small-universal-inactive" | "warning" | "webcam-active" | "webcam-inactive"
	| "activity-alpine-touring" | "activity-alpinist" | "activity-canoe" | "activity-car" | "activity-caravan" | "activity-cross-country-skis"
	| "activity-cycloturist" | "activity-downhill-skis" | "activity-ebike" | "activity-ferrata" | "activity-gravel-bike" | "activity-horse-riding"
	| "activity-ice-skates" | "activity-inline-skates" | "activity-kick-scooter" | "activity-motorcycle" | "activity-mountain-bike" | "activity-paddleboard"
	| "activity-paraglide" | "activity-plane" | "activity-road-bike" | "activity-run" | "activity-snowshoes" | "activity-stroller" | "activity-turist"
	| "path-alpine-touring" | "path-alpinist" | "path-canoe" | "path-car" | "path-caravan" | "path-cross-country-skis" | "path-cycloturist"
	| "path-downhill-skis" | "path-ebike" | "path-ferrata" | "path-gravel-bike" | "path-horse-riding" | "path-ice-skates" | "path-inline-skates"
	| "path-kick-scooter" | "path-motorcycle" | "path-mountain-bike" | "path-paddleboard" | "path-paraglide" | "path-plane" | "path-road-bike" | "path-run"
	| "path-snowshoes" | "path-stroller" | "path-turist" | "route-alpine-touring" | "route-alpinist" | "route-avoid-highway" | "route-avoid-pay" | "route-canoe"
	| "route-car" | "route-cross-country-skis" | "route-cycloturist" | "route-gravel-bike" | "route-height-profile" | "route-mhd" | "route-mountain-bike"
	| "route-multiple" | "route-plan_add" | "route-road-bike" | "route-run" | "route-turist" | "route-weather" | "wasm-flag" | "wasm-home" | "wasm-measure"
	| "wasm-no-entry-bike" | "wasm-no-entry-car" | "wasm-no-entry-walk" | "wasm-no-entry" | "wasm-path" | "wasm-star" | "wasm-suitcase" | "wasm-user-marks"
	| "wasm-warning-ferrata" | "wasm-warning-sign";

export interface ITextureData {
	x: number;
	y: number;
	width: number;
	height: number;
}

// vsechny textury
export const WASM_ALL_TEXTURE_NAMES: Array<TWasmTextureNames> = [
	"always-on-map",
	"big-active",
	"big-inactive",
	"big-universal-active",
	"big-universal-inactive",
	"geo-location",
	"height-profile",
	"little-active",
	"little-inactive",
	"measure-points-active",
	"measure-points-inactive",
	"measure-start-active",
	"measure-start-inactive",
	"mhd-boat",
	"mhd-bus",
	"mhd-cable",
	"mhd-map-boat",
	"mhd-map-bus",
	"mhd-map-cable",
	"mhd-map-metro-a",
	"mhd-map-metro-b",
	"mhd-map-metro-c",
	"mhd-map-metro-d",
	"mhd-map-metro",
	"mhd-map-train",
	"mhd-map-tram",
	"mhd-map-trolley",
	"mhd-metro-a",
	"mhd-metro-b",
	"mhd-metro-c",
	"mhd-metro-d",
	"mhd-metro",
	"mhd-standing",
	"mhd-train",
	"mhd-tram",
	"mhd-trolley",
	"mhd-walk",
	"pano",
	"photo-active",
	"photo-inactive",
	"position-share-device-active",
	"position-share-device-inactive",
	"position-share-image-active",
	"position-share-image-arrow",
	"position-share-image-inactive",
	"small-active",
	"small-gray",
	"small-inactive",
	"small-universal-active",
	"small-universal-inactive",
	"warning",
	"webcam-active",
	"webcam-inactive",
	"activity-alpine-touring",
	"activity-alpinist",
	"activity-canoe",
	"activity-car",
	"activity-caravan",
	"activity-cross-country-skis",
	"activity-cycloturist",
	"activity-downhill-skis",
	"activity-ebike",
	"activity-ferrata",
	"activity-gravel-bike",
	"activity-horse-riding",
	"activity-ice-skates",
	"activity-inline-skates",
	"activity-kick-scooter",
	"activity-motorcycle",
	"activity-mountain-bike",
	"activity-paddleboard",
	"activity-paraglide",
	"activity-plane",
	"activity-road-bike",
	"activity-run",
	"activity-snowshoes",
	"activity-stroller",
	"activity-turist",
	"path-alpine-touring",
	"path-alpinist",
	"path-canoe",
	"path-car",
	"path-caravan",
	"path-cross-country-skis",
	"path-cycloturist",
	"path-downhill-skis",
	"path-ebike",
	"path-ferrata",
	"path-gravel-bike",
	"path-horse-riding",
	"path-ice-skates",
	"path-inline-skates",
	"path-kick-scooter",
	"path-motorcycle",
	"path-mountain-bike",
	"path-paddleboard",
	"path-paraglide",
	"path-plane",
	"path-road-bike",
	"path-run",
	"path-snowshoes",
	"path-stroller",
	"path-turist",
	"route-alpine-touring",
	"route-alpinist",
	"route-avoid-highway",
	"route-avoid-pay",
	"route-canoe",
	"route-car",
	"route-cross-country-skis",
	"route-cycloturist",
	"route-gravel-bike",
	"route-height-profile",
	"route-mhd",
	"route-mountain-bike",
	"route-multiple",
	"route-plan_add",
	"route-road-bike",
	"route-run",
	"route-turist",
	"route-weather",
	"wasm-flag",
	"wasm-home",
	"wasm-measure",
	"wasm-no-entry-bike",
	"wasm-no-entry-car",
	"wasm-no-entry-walk",
	"wasm-no-entry",
	"wasm-path",
	"wasm-star",
	"wasm-suitcase",
	"wasm-user-marks",
	"wasm-warning-ferrata",
	"wasm-warning-sign",
];
// exportovane textury
const wasmTextureMapping = new Map<TWasmTextureNames, ITextureData>();

wasmTextureMapping.set("pano", { x: 0, y: 0, width: 184, height: 142 });
wasmTextureMapping.set("position-share-image-arrow", { x: 0, y: 142, width: 156, height: 156 });
wasmTextureMapping.set("big-universal-active", { x: 184, y: 0, width: 156, height: 132 });
wasmTextureMapping.set("big-universal-inactive", { x: 184, y: 132, width: 156, height: 132 });
wasmTextureMapping.set("big-active", { x: 340, y: 0, width: 154, height: 132 });
wasmTextureMapping.set("big-inactive", { x: 340, y: 132, width: 154, height: 132 });
wasmTextureMapping.set("position-share-device-active", { x: 0, y: 298, width: 120, height: 120 });
wasmTextureMapping.set("position-share-device-inactive", { x: 120, y: 298, width: 120, height: 120 });
wasmTextureMapping.set("position-share-image-active", { x: 240, y: 298, width: 120, height: 120 });
wasmTextureMapping.set("position-share-image-inactive", { x: 360, y: 298, width: 120, height: 120 });
wasmTextureMapping.set("mhd-map-boat", { x: 494, y: 0, width: 124, height: 112 });
wasmTextureMapping.set("mhd-map-cable", { x: 494, y: 112, width: 124, height: 112 });
wasmTextureMapping.set("mhd-map-metro-a", { x: 494, y: 224, width: 124, height: 112 });
wasmTextureMapping.set("mhd-map-metro-b", { x: 0, y: 418, width: 124, height: 112 });
wasmTextureMapping.set("mhd-map-metro-c", { x: 124, y: 418, width: 124, height: 112 });
wasmTextureMapping.set("mhd-map-metro", { x: 248, y: 418, width: 124, height: 112 });
wasmTextureMapping.set("mhd-map-train", { x: 372, y: 418, width: 124, height: 112 });
wasmTextureMapping.set("mhd-map-tram", { x: 618, y: 0, width: 124, height: 112 });
wasmTextureMapping.set("mhd-map-trolley", { x: 618, y: 112, width: 124, height: 112 });
wasmTextureMapping.set("mhd-map-bus", { x: 618, y: 224, width: 118, height: 112 });
wasmTextureMapping.set("mhd-map-metro-d", { x: 618, y: 336, width: 118, height: 112 });
wasmTextureMapping.set("webcam-active", { x: 0, y: 530, width: 128, height: 98 });
wasmTextureMapping.set("webcam-inactive", { x: 128, y: 530, width: 128, height: 98 });
wasmTextureMapping.set("small-active", { x: 496, y: 418, width: 104, height: 88 });
wasmTextureMapping.set("small-inactive", { x: 256, y: 530, width: 104, height: 88 });
wasmTextureMapping.set("small-universal-active", { x: 360, y: 530, width: 104, height: 88 });
wasmTextureMapping.set("small-universal-inactive", { x: 464, y: 530, width: 104, height: 88 });
wasmTextureMapping.set("small-gray", { x: 0, y: 628, width: 96, height: 92 });
wasmTextureMapping.set("wasm-warning-ferrata", { x: 618, y: 448, width: 80, height: 80 });
wasmTextureMapping.set("photo-active", { x: 494, y: 336, width: 65, height: 65 });
wasmTextureMapping.set("photo-inactive", { x: 568, y: 530, width: 65, height: 65 });
wasmTextureMapping.set("always-on-map", { x: 559, y: 336, width: 52, height: 52 });
wasmTextureMapping.set("mhd-boat", { x: 633, y: 530, width: 48, height: 48 });
wasmTextureMapping.set("mhd-bus", { x: 681, y: 530, width: 48, height: 48 });
wasmTextureMapping.set("mhd-cable", { x: 96, y: 628, width: 48, height: 48 });
wasmTextureMapping.set("mhd-metro-a", { x: 144, y: 628, width: 48, height: 48 });
wasmTextureMapping.set("mhd-metro-b", { x: 192, y: 628, width: 48, height: 48 });
wasmTextureMapping.set("mhd-metro-c", { x: 240, y: 628, width: 48, height: 48 });
wasmTextureMapping.set("mhd-metro-d", { x: 288, y: 628, width: 48, height: 48 });
wasmTextureMapping.set("mhd-metro", { x: 336, y: 628, width: 48, height: 48 });
wasmTextureMapping.set("mhd-standing", { x: 384, y: 628, width: 48, height: 48 });
wasmTextureMapping.set("mhd-train", { x: 432, y: 628, width: 48, height: 48 });
wasmTextureMapping.set("mhd-tram", { x: 480, y: 628, width: 48, height: 48 });
wasmTextureMapping.set("mhd-trolley", { x: 528, y: 628, width: 48, height: 48 });
wasmTextureMapping.set("mhd-walk", { x: 576, y: 628, width: 48, height: 48 });
wasmTextureMapping.set("activity-alpine-touring", { x: 624, y: 628, width: 48, height: 48 });
wasmTextureMapping.set("activity-alpinist", { x: 672, y: 628, width: 48, height: 48 });
wasmTextureMapping.set("activity-canoe", { x: 742, y: 0, width: 48, height: 48 });
wasmTextureMapping.set("activity-car", { x: 742, y: 48, width: 48, height: 48 });
wasmTextureMapping.set("activity-caravan", { x: 742, y: 96, width: 48, height: 48 });
wasmTextureMapping.set("activity-cross-country-skis", { x: 742, y: 144, width: 48, height: 48 });
wasmTextureMapping.set("activity-cycloturist", { x: 742, y: 192, width: 48, height: 48 });
wasmTextureMapping.set("activity-downhill-skis", { x: 742, y: 240, width: 48, height: 48 });
wasmTextureMapping.set("activity-ebike", { x: 742, y: 288, width: 48, height: 48 });
wasmTextureMapping.set("activity-ferrata", { x: 742, y: 336, width: 48, height: 48 });
wasmTextureMapping.set("activity-gravel-bike", { x: 742, y: 384, width: 48, height: 48 });
wasmTextureMapping.set("activity-horse-riding", { x: 742, y: 432, width: 48, height: 48 });
wasmTextureMapping.set("activity-ice-skates", { x: 742, y: 480, width: 48, height: 48 });
wasmTextureMapping.set("activity-inline-skates", { x: 742, y: 528, width: 48, height: 48 });
wasmTextureMapping.set("activity-kick-scooter", { x: 742, y: 576, width: 48, height: 48 });
wasmTextureMapping.set("activity-motorcycle", { x: 742, y: 624, width: 48, height: 48 });
wasmTextureMapping.set("activity-mountain-bike", { x: 742, y: 672, width: 48, height: 48 });
wasmTextureMapping.set("activity-paddleboard", { x: 0, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("activity-paraglide", { x: 48, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("activity-plane", { x: 96, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("activity-road-bike", { x: 144, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("activity-run", { x: 192, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("activity-snowshoes", { x: 240, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("activity-stroller", { x: 288, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("activity-turist", { x: 336, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("path-alpine-touring", { x: 384, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("path-alpinist", { x: 432, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("path-canoe", { x: 480, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("path-car", { x: 528, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("path-caravan", { x: 576, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("path-cross-country-skis", { x: 624, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("path-cycloturist", { x: 672, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("path-downhill-skis", { x: 720, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("path-ebike", { x: 790, y: 0, width: 48, height: 48 });
wasmTextureMapping.set("path-ferrata", { x: 790, y: 48, width: 48, height: 48 });
wasmTextureMapping.set("path-gravel-bike", { x: 790, y: 96, width: 48, height: 48 });
wasmTextureMapping.set("path-horse-riding", { x: 790, y: 144, width: 48, height: 48 });
wasmTextureMapping.set("path-ice-skates", { x: 790, y: 192, width: 48, height: 48 });
wasmTextureMapping.set("path-inline-skates", { x: 790, y: 240, width: 48, height: 48 });
wasmTextureMapping.set("path-kick-scooter", { x: 790, y: 288, width: 48, height: 48 });
wasmTextureMapping.set("path-motorcycle", { x: 790, y: 336, width: 48, height: 48 });
wasmTextureMapping.set("path-mountain-bike", { x: 790, y: 384, width: 48, height: 48 });
wasmTextureMapping.set("path-paddleboard", { x: 790, y: 432, width: 48, height: 48 });
wasmTextureMapping.set("path-paraglide", { x: 790, y: 480, width: 48, height: 48 });
wasmTextureMapping.set("path-plane", { x: 790, y: 528, width: 48, height: 48 });
wasmTextureMapping.set("path-road-bike", { x: 790, y: 576, width: 48, height: 48 });
wasmTextureMapping.set("path-run", { x: 790, y: 624, width: 48, height: 48 });
wasmTextureMapping.set("path-snowshoes", { x: 790, y: 672, width: 48, height: 48 });
wasmTextureMapping.set("path-stroller", { x: 790, y: 720, width: 48, height: 48 });
wasmTextureMapping.set("path-turist", { x: 0, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-alpine-touring", { x: 48, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-alpinist", { x: 96, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-canoe", { x: 144, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-car", { x: 192, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-cross-country-skis", { x: 240, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-cycloturist", { x: 288, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-gravel-bike", { x: 336, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-height-profile", { x: 384, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-mhd", { x: 432, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-mountain-bike", { x: 480, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-multiple", { x: 528, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-plan_add", { x: 576, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-road-bike", { x: 624, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-run", { x: 672, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-turist", { x: 720, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("route-weather", { x: 768, y: 768, width: 48, height: 48 });
wasmTextureMapping.set("wasm-flag", { x: 838, y: 0, width: 48, height: 48 });
wasmTextureMapping.set("wasm-home", { x: 838, y: 48, width: 48, height: 48 });
wasmTextureMapping.set("wasm-measure", { x: 838, y: 96, width: 48, height: 48 });
wasmTextureMapping.set("wasm-no-entry-bike", { x: 838, y: 144, width: 48, height: 48 });
wasmTextureMapping.set("wasm-no-entry-car", { x: 838, y: 192, width: 48, height: 48 });
wasmTextureMapping.set("wasm-no-entry-walk", { x: 838, y: 240, width: 48, height: 48 });
wasmTextureMapping.set("wasm-no-entry", { x: 838, y: 288, width: 48, height: 48 });
wasmTextureMapping.set("wasm-path", { x: 838, y: 336, width: 48, height: 48 });
wasmTextureMapping.set("wasm-star", { x: 838, y: 384, width: 48, height: 48 });
wasmTextureMapping.set("wasm-suitcase", { x: 838, y: 432, width: 48, height: 48 });
wasmTextureMapping.set("wasm-user-marks", { x: 838, y: 480, width: 48, height: 48 });
wasmTextureMapping.set("wasm-warning-sign", { x: 838, y: 528, width: 48, height: 48 });
wasmTextureMapping.set("little-active", { x: 838, y: 576, width: 48, height: 38 });
wasmTextureMapping.set("little-inactive", { x: 838, y: 614, width: 48, height: 38 });
wasmTextureMapping.set("geo-location", { x: 838, y: 652, width: 40, height: 40 });
wasmTextureMapping.set("height-profile", { x: 838, y: 692, width: 40, height: 40 });
wasmTextureMapping.set("route-avoid-highway", { x: 838, y: 732, width: 40, height: 40 });
wasmTextureMapping.set("route-avoid-pay", { x: 838, y: 772, width: 40, height: 40 });
wasmTextureMapping.set("warning", { x: 698, y: 448, width: 32, height: 33 });
wasmTextureMapping.set("measure-points-active", { x: 698, y: 481, width: 28, height: 28 });
wasmTextureMapping.set("measure-points-inactive", { x: 340, y: 264, width: 28, height: 28 });
wasmTextureMapping.set("measure-start-active", { x: 368, y: 264, width: 28, height: 28 });
wasmTextureMapping.set("measure-start-inactive", { x: 396, y: 264, width: 28, height: 28 });

export default function getWasmTexturesData(name: TWasmTextureNames): ITextureData | null {
	return wasmTextureMapping.get(name) || null;
}


export function getWasmTexturesScale() {
	return 2;
}
